exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".save-message-logo img{\r\n    width: 200px;\r\n}\r\n\r\n.save-message-logo .dialog-logo{\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.save-message-logo{\r\n    text-align: center;\r\n}\r\n\r\n.save-message-logo .text{\r\n    font-size: 1.25rem;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.save-message-logo button{\r\n    color: #fff;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n    .save-message-logo .dialog-logo {\r\n        margin-bottom: 20px;\r\n    }\r\n    .save-message-logo .text {\r\n        font-size: 1rem;\r\n    }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/save-message/save-message.component.css
// module id = ../../../../../src/app/directive/save-message/save-message.component.css
// module chunks = main